import { motion } from "framer-motion";

// Line-by-line masked reveal helper
export function RevealLines({ lines = [], className = "", delay = 0, lineDelay = 0.12, duration = 0.9 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask" style={{ display: "block" }}>
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration, delay: delay + i * lineDelay, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Fade+rise on scroll into view
export function Rise({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

// Masked line for scroll-triggered text
export function LineRise({ children, delay = 0, className = "" }) {
  // Render niets bij lege content — voorkomt lege regels in display-titels
  if (children === null || children === undefined || children === "") return null;
  // whileInView zit op het ongetransformeerde masker; anders blijft het volledig
  // geclipte binnenelement onzichtbaar (IntersectionObserver ziet het nooit).
  return (
    <motion.span
      className={`reveal-mask${className ? " " + className : ""}`}
      style={{ display: "block" }}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-40px" }}
    >
      <motion.span
        className="block"
        variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}
